import { render, staticRenderFns } from "./MoreActions.vue?vue&type=template&id=b54f427e&scoped=true"
import script from "./MoreActions.vue?vue&type=script&lang=js"
export * from "./MoreActions.vue?vue&type=script&lang=js"
import style0 from "./MoreActions.vue?vue&type=style&index=0&id=b54f427e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54f427e",
  null
  
)

export default component.exports